define('AwaLabs.FacetRangeAccessible', [
    'Facets.FacetedNavigationItem.View',
    'SC.Configuration',
    'jQuery',
    'Backbone',
    'underscore'
], function FacetRangeAccessible(
    FacetsFacetedNavigationItemView,
    Configuration,
    jQuery,
    Backbone,
    _
) {
    'use strict';

    _.extend(FacetsFacetedNavigationItemView.prototype, {
        events: _.extend(FacetsFacetedNavigationItemView.prototype.events, {
            'submit [data-action=filter-range]': 'filterRange'
        }),
        filterRange: function filterRange(e) {
            var $rangeForm = jQuery(e.currentTarget);
            var min = $rangeForm.find('[data-value="min"]').val();
            var max = $rangeForm.find('[data-value="max"]').val();
            var translator = this.options.translator;

            e.preventDefault();
            e.stopPropagation();

            this.$('.facets-faceted-navigation-item-custom-range-error').hide();

            if (min && max) {
                Backbone.history.navigate(
                    translator
                        .cloneForFacetId($rangeForm.data('facetId'), {
                            from: parseInt(min, 10),
                            to: parseInt(max, 10)
                        })
                        .getUrl(),
                    {
                        trigger: true
                    }
                );
            } else {
                this.$('.facets-faceted-navigation-item-custom-range-error').show();
            }
        },
        getContext: _.wrap(FacetsFacetedNavigationItemView.prototype.getContext, function wrapContext(fn) {
            var originalContext = fn.apply(this, _.toArray(arguments).slice(1));
            var translator = this.options.translator;
            var predefinedValues = Configuration.get('facetRange.predefinedValues');
            if (originalContext.facetDisplayName === 'Brand') {
                originalContext.values = _.sortBy(originalContext.values, function sortBy(value) {
                    return value.displayName.toLowerCase().trimStart();
                });
                originalContext.extraValues = _.sortBy(originalContext.extraValues, function sortBy(value) {
                    return value.displayName.toLowerCase().trimStart();
                });
                if (originalContext.displayValues && originalContext.displayValues.length) {
                    originalContext.displayValues = originalContext.values.slice(0, originalContext.displayValues.length);
                    originalContext.extraValues = originalContext.values.slice(originalContext.displayValues.length, originalContext.values.length);
                }
            }
            if (originalContext.isRange) {
                originalContext.priceRangeValues = _.filter(predefinedValues, function filterRange(value) {
                    if (value.max === 'max') {
                        value.max = originalContext.rangeMax;
                    }
                    value.link = translator.cloneForFacetId(originalContext.facetId, {
                        from: value.min,
                        to: value.max
                    }).getUrl();
                    value.isActive = false;
                    if (
                        parseInt(value.min, 10) === parseInt(originalContext.rangeFrom, 10) &&
                        parseInt(value.max, 10) === parseInt(originalContext.rangeTo, 10)
                    ) {
                        value.link = translator.cloneWithoutFacetId(originalContext.facetId).getUrl();
                        value.isActive = true;
                    }
                    return parseInt(value.min, 10) < parseInt(originalContext.rangeTo, 10);
                });
                originalContext.rangeErrorText = 'Please fill min and max values';
            }
            return originalContext;
        })
    });
});
